export { default as Table } from './components/table';
export { default as Tbody } from './components/tbody';
export { default as Td } from './components/td';
export { default as Thead } from './components/thead';
export { default as Tr } from './components/tr';
